<template>
  <div
    class="c-recentOrderService"
    v-if="recentOrderServiceList.length"
  >
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide c-recentOrderService_slide"
          v-for="(recentOrderService, index) in recentOrderServiceList"
          :key="`${index}_${recentOrderService.orderDate}`"
        >
          <p class="c-recentOrderService_text">
            <span class="c-recentOrderService_congrats">Congrats!</span>
            <span class="c-recentOrderService_service">
              <a
                :href="addQueryToUrlIfBusinessPreview(`/services/${recentOrderService.serviceId}?ref=recent_order`)"
                target="_blank"
              >
                {{ recentOrderService.serviceName }}
              </a>
            </span>
            <span class="c-recentOrderService_user">
              by
              <a
                :href="addQueryToUrlIfBusinessPreview(`/users/${recentOrderService.userId}`)"
                target="_blank"
              >
                {{ recentOrderService.userName }}
              </a>
            </span>
            <span>が購入されました。</span>
          </p>
          <p class="c-recentOrderService_time">
            <span class="c-recentOrderService_orderDate">
              {{ $util.prettyDate(recentOrderService.orderDate) }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Swiper SSR https://github.com/surmon-china/surmon-china.github.io/tree/source/projects/vue-awesome-swiper/nuxt
import { directive } from 'vue-awesome-swiper'

import businessMixin from '~/mixins/pages/business-mixin'

import { mapState } from 'vuex'
export default {
  name: 'RecentOrderService',
  directives: {
    swiper: directive
  },
  mixins: [businessMixin],
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        height: 36,
        spaceBetween: 12,
        speed: 1200,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        }
      }
    }
  },
  computed: {
    ...mapState('pages/search/seo', ['recentOrderServiceList'])
  }
}
</script>
<style lang="scss" scoped>
.c-recentOrderService {
  overflow: hidden;
  margin-bottom: 20px;
  height: 36px;

  a {
    @include link-effect;

    color: $ds2-color-gray-900;
  }

  p {
    margin: 0;
  }

  &_slide {
    display: flex;
    padding: 0 12px;
    background-color: #f8f8f8;
    font-size: 13px;
    line-height: 36px;

    justify-content: space-between;
  }

  &_text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &_congrats {
    font-weight: bold;
  }

  &_service {
    a {
      color: $ds2-color-gray-900;
    }
  }

  &_user {
    color: $ds2-color-gray-600;
    font-size: 11px;

    a {
      color: $ds2-color-gray-600;
    }
  }

  &_time {
    margin-left: 12px;
    white-space: nowrap;
  }

  &_orderDate {
    color: $ds2-color-gray-600;
  }
}
</style>
